import { getUnifiedContractStatus, UNIFIED_STATUS_LABELS, UNIFIED_STATUS_STYLES } from '@/features/contracts/types/contract.types';

interface ContractBadgeProps {
  status: number;
  monthlyPaymentId?: string | null;
  monthlyPaymentStatus?: string | null;
  cancelationRequested?: boolean;
  cancelationRequestedAt?: string | null;
}

/**
 * Badge coloré pour afficher le statut unifié d'un contrat
 * Prend en compte la mensualisation et les demandes d'annulation
 */
export function ContractBadge({ status, monthlyPaymentId, monthlyPaymentStatus, cancelationRequested, cancelationRequestedAt }: ContractBadgeProps) {
  const unified = getUnifiedContractStatus({ idStatus: status, monthlyPaymentId, monthlyPaymentStatus, cancelationRequested });
  const label = UNIFIED_STATUS_LABELS[unified];
  const styles = UNIFIED_STATUS_STYLES[unified];

  const badge = (
    <span
      className={`tw-inline-flex tw-items-center tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium ${styles}`}
    >
      {label}
    </span>
  );

  if (unified === 'pending_cancellation' && cancelationRequestedAt) {
    return (
      <div className="tw-inline-flex tw-flex-col">
        {badge}
        <span className="tw-text-[10px] tw-text-orange-600 tw-mt-0.5">
          {new Date(cancelationRequestedAt).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
        </span>
      </div>
    );
  }

  return badge;
}
